@if (!hasFailed()) {

  <lib-ai-button [isLoading]="isLoading()" (click)="toggleInsights($event)"/>

  @if (showInsights()) {
    <div class="insight-container" [@popIn]="extendedState()">
      <div class="outer-nav">
        <ng-template [ngTemplateOutlet]="bgImage"/>

        <lib-insight-button
          label="previous insight"
          [icon]="SvgSpriteIcon.ArrowLeft"
          class="nav-button"
          [class.disabled]="swiperRef().nativeElement.swiper.isBeginning"
          (click)="swiperRef().nativeElement.swiper.slidePrev()"/>
        <lib-insight-button
          label="next insight"
          [icon]="SvgSpriteIcon.ArrowRight"
          class="nav-button"
          [class.disabled]="swiperRef().nativeElement.swiper.isEnd"
          (click)="swiperRef().nativeElement.swiper.slideNext()"/>

        <ng-template [ngTemplateOutlet]="stateButtons"/>
      </div>

      <swiper-container
        #swiper
      >
        @for (insight of insights(); track insight) {
          <swiper-slide>
            <div class="insight">
              <ng-template [ngTemplateOutlet]="bgImage"/>

              <div class="header">
                <lib-insight-tag [insightType]="insight.type"/>

                <ng-template [ngTemplateOutlet]="stateButtons"/>
              </div>

              <h3>{{ insight.title }}</h3>
              <p>{{ insight.summary }}</p>
              <p class="details">{{ insight.extendedContent }}</p>
            </div>
          </swiper-slide>
        }
      </swiper-container>
    </div>
  }
}

<ng-template #bgImage>
  <svg width="194" height="93" class="illustration" viewBox="0 0 194 93" fill="none">
    <g clip-path="url(#clip0_3174_65258)">
      <path
        d="M63.9503 -205.049C97.9345 -239.034 135.572 -262.895 168.933 -274.015C202.325 -285.146 231.271 -283.468 248.079 -266.661C264.886 -249.853 266.563 -220.907 255.433 -187.515C244.312 -154.155 220.451 -116.517 186.467 -82.5327C152.483 -48.5485 114.845 -24.6872 81.4844 -13.567C48.0923 -2.43632 19.1464 -4.11317 2.33881 -20.9205C-14.4688 -37.7281 -16.1462 -66.6744 -5.01539 -100.067C6.10479 -133.427 29.966 -171.065 63.9503 -205.049Z"
        stroke="#002ACC"/>
      <path
        d="M71.3233 -197.677C105.308 -231.661 142.945 -255.522 176.306 -266.642C209.698 -277.773 238.645 -276.096 255.452 -259.288C272.259 -242.481 273.936 -213.535 262.806 -180.143C251.685 -146.782 227.824 -109.144 193.84 -75.1602C159.856 -41.1759 122.218 -17.3146 88.8574 -6.19446C55.4653 4.93623 26.5195 3.25939 9.71186 -13.5479C-7.09575 -30.3555 -8.77311 -59.3019 2.35766 -92.6942C13.4778 -126.055 37.3391 -163.692 71.3233 -197.677Z"
        stroke="#002ACC"/>
      <path
        d="M78.6944 -190.304C112.679 -224.288 150.316 -248.15 183.677 -259.27C217.069 -270.401 246.016 -268.723 262.823 -251.916C279.631 -235.108 281.307 -206.162 270.177 -172.77C259.057 -139.41 235.195 -101.772 201.211 -67.7876C167.227 -33.8033 129.589 -9.94209 96.2285 1.1781C62.8364 12.3088 33.8906 10.6319 17.083 -6.17538C0.275347 -22.983 -1.40201 -51.9293 9.72875 -85.3216C20.8489 -118.682 44.7102 -156.32 78.6944 -190.304Z"
        stroke="#002ACC"/>
      <path
        d="M86.0675 -182.932C120.052 -216.916 157.69 -240.777 191.05 -251.897C224.442 -263.028 253.389 -261.351 270.196 -244.543C287.004 -227.736 288.68 -198.79 277.55 -165.398C266.43 -132.037 242.568 -94.3993 208.584 -60.4151C174.6 -26.4308 136.962 -2.56953 103.602 8.55066C70.2094 19.6814 41.2636 18.0045 24.456 1.19718C7.64839 -15.6104 5.97103 -44.5567 17.1018 -77.9491C28.222 -111.31 52.0832 -148.947 86.0675 -182.932Z"
        stroke="#002ACC"/>
      <path
        d="M56.5772 -212.422C90.5615 -246.406 128.199 -270.267 161.56 -281.388C194.952 -292.518 223.898 -290.841 240.706 -274.034C257.513 -257.226 259.19 -228.28 248.06 -194.888C236.939 -161.527 213.078 -123.89 179.094 -89.9054C145.11 -55.9211 107.472 -32.0599 74.1113 -20.9397C40.7192 -9.80901 11.7734 -11.4858 -5.03423 -28.2932C-21.8418 -45.1008 -23.5192 -74.0471 -12.3884 -107.439C-1.26825 -140.8 22.593 -178.438 56.5772 -212.422Z"
        stroke="#002ACC"/>
      <path
        d="M93.4405 -175.559C127.425 -209.543 165.063 -233.405 198.423 -244.525C231.815 -255.656 260.762 -253.978 277.569 -237.171C294.377 -220.363 296.054 -191.417 284.923 -158.025C273.803 -124.665 249.941 -87.0268 215.957 -53.0425C181.973 -19.0582 144.335 4.80303 110.975 15.9232C77.5825 27.0539 48.6367 25.3771 31.829 8.56973C15.0214 -8.23787 13.3441 -37.1842 24.4748 -70.5765C35.595 -103.937 59.4563 -141.575 93.4405 -175.559Z"
        stroke="#002ACC"/>
      <path
        d="M100.814 -168.186C134.798 -202.17 172.436 -226.031 205.796 -237.152C239.188 -248.282 268.135 -246.605 284.942 -229.797C301.75 -212.99 303.427 -184.044 292.296 -150.652C281.176 -117.291 257.314 -79.6535 223.33 -45.6692C189.346 -11.6849 151.708 12.1763 118.348 23.2965C84.9555 34.4272 56.0097 32.7504 39.2021 15.943C22.3945 -0.864576 20.7171 -29.8109 31.8479 -63.2032C42.9681 -96.5638 66.8293 -134.201 100.814 -168.186Z"
        stroke="#002ACC"/>
      <path
        d="M108.187 -160.813C142.171 -194.797 179.809 -218.659 213.169 -229.779C246.561 -240.91 275.508 -239.232 292.315 -222.425C309.123 -205.617 310.8 -176.671 299.669 -143.279C288.549 -109.919 264.687 -72.2809 230.703 -38.2966C196.719 -4.31238 159.081 19.5489 125.721 30.6691C92.3286 41.7998 63.3828 40.1229 46.5751 23.3156C29.7675 6.50798 28.0902 -22.4383 39.2209 -55.8307C50.3411 -89.1912 74.2024 -126.829 108.187 -160.813Z"
        stroke="#002ACC"/>
      <path
        d="M115.556 -153.444C149.54 -187.428 187.178 -211.289 220.538 -222.41C253.931 -233.54 282.877 -231.863 299.685 -215.055C316.492 -198.248 318.169 -169.302 307.038 -135.91C295.918 -102.549 272.057 -64.9115 238.072 -30.9273C204.088 3.05701 166.45 26.9183 133.09 38.0385C99.6977 49.1691 70.7519 47.4923 53.9443 30.685C37.1367 13.8774 35.4593 -15.0689 46.5901 -48.4613C57.7103 -81.8218 81.5715 -119.46 115.556 -153.444Z"
        stroke="#002ACC"/>
      <path
        d="M122.931 -146.068C156.915 -180.052 194.553 -203.914 227.913 -215.034C261.306 -226.165 290.252 -224.487 307.06 -207.68C323.867 -190.872 325.544 -161.926 314.413 -128.534C303.293 -95.1736 279.432 -57.5358 245.447 -23.5515C211.463 10.4327 173.825 34.294 140.465 45.4142C107.073 56.5449 78.1269 54.868 61.3193 38.0607C44.5117 21.2531 42.8343 -7.69322 53.9651 -41.0855C65.0853 -74.4461 88.9465 -112.084 122.931 -146.068Z"
        stroke="#002ACC"/>
      <path
        d="M130.3 -138.699C164.284 -172.683 201.922 -196.544 235.282 -207.665C268.675 -218.795 297.621 -217.118 314.429 -200.311C331.236 -183.503 332.913 -154.557 321.782 -121.165C310.662 -87.8044 286.801 -50.1666 252.817 -16.1824C218.832 17.8019 181.195 41.6631 147.834 52.7833C114.442 63.914 85.4961 62.2372 68.6884 45.4298C51.8808 28.6222 50.2035 -0.324075 61.3342 -33.7164C72.4544 -67.0769 96.3156 -104.715 130.3 -138.699Z"
        stroke="#002ACC"/>
      <path
        d="M137.673 -131.326C171.657 -165.31 209.295 -189.172 242.656 -200.292C276.048 -211.423 304.994 -209.745 321.802 -192.938C338.609 -176.13 340.286 -147.184 329.155 -113.792C318.035 -80.4317 294.174 -42.7939 260.19 -8.80965C226.205 25.1746 188.568 49.0359 155.207 60.1561C121.815 71.2868 92.8691 69.6099 76.0615 52.8026C59.2539 35.995 57.5765 7.04867 68.7073 -26.3437C79.8274 -59.7042 103.689 -97.3419 137.673 -131.326Z"
        stroke="#002ACC"/>
      <path
        d="M145.046 -123.954C179.03 -157.938 216.668 -181.799 250.029 -192.919C283.421 -204.05 312.367 -202.373 329.175 -185.565C345.982 -168.758 347.659 -139.812 336.528 -106.42C325.408 -73.0591 301.547 -35.4213 267.563 -1.43703C233.578 32.5472 195.941 56.4085 162.58 67.5287C129.188 78.6594 100.242 76.9825 83.4345 60.1752C66.6269 43.3676 64.9495 14.4213 76.0803 -18.971C87.2005 -52.3316 111.062 -89.9693 145.046 -123.954Z"
        stroke="#002ACC"/>
      <path
        d="M152.419 -116.581C186.403 -150.565 224.041 -174.427 257.402 -185.547C290.794 -196.678 319.74 -195 336.548 -178.193C353.355 -161.385 355.032 -132.439 343.901 -99.0472C332.781 -65.6867 308.92 -28.0489 274.936 5.93535C240.951 39.9196 203.314 63.7809 169.953 74.9011C136.561 86.0318 107.615 84.3549 90.8076 67.5476C74 50.74 72.3226 21.7937 83.4534 -11.5987C94.5735 -44.9592 118.435 -82.5969 152.419 -116.581Z"
        stroke="#002ACC"/>
      <path
        d="M159.79 -109.209C193.774 -143.193 231.412 -167.054 264.773 -178.174C298.165 -189.305 327.111 -187.628 343.919 -170.82C360.726 -154.012 362.403 -125.067 351.272 -91.6746C340.152 -58.314 316.291 -20.6762 282.307 13.308C248.322 47.2923 210.685 71.1536 177.324 82.2737C143.932 93.4044 114.986 91.7276 98.1787 74.9203C81.371 58.1127 79.6937 29.1663 90.8245 -4.22598C101.945 -37.5865 125.806 -75.2243 159.79 -109.209Z"
        stroke="#002ACC"/>
    </g>
    <defs>
      <clipPath id="clip0_3174_65258">
        <rect width="194" height="93" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</ng-template>

<ng-template #stateButtons>
  <lib-insight-button
    label="show more"
    class="details-button"
    [icon]="SvgSpriteIcon.ChevronDown"
    (click)="toggleDetails($event)"/>
  <lib-insight-button
    label="hide insights"
    class="close-button"
    [icon]="SvgSpriteIcon.CloseInsight"
    (click)="toggleInsights($event)"/>
</ng-template>
